import { BaseObject } from "@adgate/common/types/base-object.type";

export class ChannelFamily extends BaseObject
{
    public static USAGE_TV: number              = 1;
    public static USAGE_STREAMING: number       = 2;
}